/* unplugin-vue-components disabled */import script from "./NoitceDetaill.vue?vue&type=script&setup=true&name=NoticeDetaill&lang=js"
export * from "./NoitceDetaill.vue?vue&type=script&setup=true&name=NoticeDetaill&lang=js"

import "./NoitceDetaill.vue?vue&type=style&index=0&id=b9611f0c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9611f0c"]])

export default __exports__